;(function(global) {
	'use strict';

	var hoverintent = function(el, onOver, onOut) {
		var x, y, pX, pY;
		var h = {},
				state = 0,
				timer = 0;

		var options = {
			sensitivity: 7,
			interval: 100,
			timeout: 0
		};

		function delay(el, e) {
			if (timer) timer = clearTimeout(timer);
			state = 0;
			return onOut.call(el, e);
		}

		function tracker(e) {
			x = e.clientX;
			y = e.clientY;
		}

		function compare(el, e) {
			if (timer) timer = clearTimeout(timer);
			if ((Math.abs(pX - x) + Math.abs(pY - y)) < options.sensitivity) {
				state = 1;
				return onOver.call(el, e);
			} else {
				pX = x;
				pY = y;
				timer = setTimeout(function() {
					compare(el, e);
				}, options.interval);
			}
		}

		// Public methods
		h.options = function(opt) {
			options = Object.assign({}, options, opt);
			return h;
		};

		function dispatchOver(e) {
			if (timer) timer = clearTimeout(timer);
			el.removeEventListener('mousemove', tracker, false);

			if (state !== 1) {
				pX = e.clientX;
				pY = e.clientY;

				el.addEventListener('mousemove', tracker, false);

				timer = setTimeout(function() {
					compare(el, e);
				}, options.interval);
			}

			return this;
		}

		function dispatchOut(e) {
			if (timer) timer = clearTimeout(timer);
			el.removeEventListener('mousemove', tracker, false);

			if (state === 1) {
				timer = setTimeout(function() {
					delay(el, e);
				}, options.timeout);
			}

			return this;
		}

		h.remove = function() {
			if (!el) return;
			el.removeEventListener('mouseover', dispatchOver, false);
			el.removeEventListener('mouseout', dispatchOut, false);
		};

		if (el) {
			el.addEventListener('mouseover', dispatchOver, false);
			el.addEventListener('mouseout', dispatchOut, false);
		}

		return h;
	};

	global.hoverintent = hoverintent;
	if (typeof module !== 'undefined' && module.exports) module.exports = hoverintent;
})(this);

define("plugins/hoverIntent/hoverintent", function(){});

